/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    DocumentPreferences,
    DocumentPreferencesFromJSON,
    DocumentPreferencesFromJSONTyped,
    DocumentPreferencesToJSON,
} from './';

/**
 * 
 * @export
 * @interface Preferences
 */
export interface Preferences {
    /**
     * 
     * @type {boolean}
     * @memberof Preferences
     */
    autoAddFirstObjection?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Preferences
     */
    includeGeneralObjections?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Preferences
     */
    hasSeenIntroTutorial?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Preferences
     */
    hasSeenSuggestBetaTutorial?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof Preferences
     */
    hasSeenAutodocTutorial?: boolean;
    /**
     * 
     * @type {DocumentPreferences}
     * @memberof Preferences
     */
    documentPreferences?: DocumentPreferences;
    /**
     * 
     * @type {{ [key: string]: DocumentPreferences; }}
     * @memberof Preferences
     */
    jurisdictionSpecificDocumentPreferences?: { [key: string]: DocumentPreferences; } | null;
}

export function PreferencesFromJSON(json: any): Preferences {
    return PreferencesFromJSONTyped(json, false);
}

export function PreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Preferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'autoAddFirstObjection': !exists(json, 'autoAddFirstObjection') ? undefined : json['autoAddFirstObjection'],
        'includeGeneralObjections': !exists(json, 'includeGeneralObjections') ? undefined : json['includeGeneralObjections'],
        'hasSeenIntroTutorial': !exists(json, 'hasSeenIntroTutorial') ? undefined : json['hasSeenIntroTutorial'],
        'hasSeenSuggestBetaTutorial': !exists(json, 'hasSeenSuggestBetaTutorial') ? undefined : json['hasSeenSuggestBetaTutorial'],
        'hasSeenAutodocTutorial': !exists(json, 'hasSeenAutodocTutorial') ? undefined : json['hasSeenAutodocTutorial'],
        'documentPreferences': !exists(json, 'documentPreferences') ? undefined : DocumentPreferencesFromJSON(json['documentPreferences']),
        'jurisdictionSpecificDocumentPreferences': !exists(json, 'jurisdictionSpecificDocumentPreferences') ? undefined : (json['jurisdictionSpecificDocumentPreferences'] === null ? null : mapValues(json['jurisdictionSpecificDocumentPreferences'], DocumentPreferencesFromJSON)),
    };
}

export function PreferencesToJSON(value?: Preferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'autoAddFirstObjection': value.autoAddFirstObjection,
        'includeGeneralObjections': value.includeGeneralObjections,
        'hasSeenIntroTutorial': value.hasSeenIntroTutorial,
        'hasSeenSuggestBetaTutorial': value.hasSeenSuggestBetaTutorial,
        'hasSeenAutodocTutorial': value.hasSeenAutodocTutorial,
        'documentPreferences': DocumentPreferencesToJSON(value.documentPreferences),
        'jurisdictionSpecificDocumentPreferences': value.jurisdictionSpecificDocumentPreferences === undefined ? undefined : (value.jurisdictionSpecificDocumentPreferences === null ? null : mapValues(value.jurisdictionSpecificDocumentPreferences, DocumentPreferencesToJSON)),
    };
}


